/* Document ready functions */
jQuery(document).ready(function ($){

    var start_date = new Date();
    var sd = start_date.getDate();
    var sm = ((start_date.getMonth() + 1) < 10 ? '0' : '') + (start_date.getMonth() + 1);
    var sy = start_date.getFullYear();
    start_date = sy+'-'+sm+'-'+sd;

    var end_date;
    var end_date = new Date();
    var ed = end_date.getDate();
    var em = ((end_date.getMonth() + 1) < 10 ? '0' : '') + (end_date.getMonth() + 1);
    var ey = end_date.getFullYear();
    end_date = ey+'-'+em+'-'+ed;

    var booking_url;

    var header_location = $('.topline-section .town select').children("option:selected").val();
    var body_location = $('.book-room .town select').children("option:selected").val();

    var header_booking_url = 'https://'+header_location+'.nitesoft.se/units/'+start_date+'/'+end_date+'//2';
    $('.topline-section .booking_btn').attr('href', header_booking_url);

    var body_booking_url = 'https://'+body_location+'.nitesoft.se/units/'+start_date+'/'+end_date+'//2';
    $('.book-room .booking_btn').attr('href', body_booking_url);

    $('.topline-section .town select').change(function(){
        header_location = $(this).children("option:selected").val();
        booking_url = 'https://'+header_location+'.nitesoft.se/units/'+start_date+'/'+end_date+'//2';
        $('.topline-section .booking_btn').attr('href', booking_url);
    });

    $('.book-room .town select').change(function(){
        body_location = $(this).children("option:selected").val();
        booking_url = 'https://'+body_location+'.nitesoft.se/units/'+start_date+'/'+end_date+'//2';
        $('.topline-section .booking_btn').attr('href', booking_url);
    });

    var picker = new Pikaday({
        field: document.getElementById('arrival'),
        position: 'left-aligned',
        firstDay: 1,
        i18n: {
        previousMonth : 'Föregående månad',
        nextMonth     : 'Nästa månad',
        months        : ['Januari','Februari','Mars','April','Maj','Juni','Juli','Augusti','September','Oktober','November','December'],
        weekdays      : ['Söndag','Måndag','Tisdag','Onsdag','Torsdag','Fredag','Lördag'],
        weekdaysShort : ['Sön','Mån','Tis','Ons','Tor','Fre','Lör']
        },
        minDate: new Date(),
        onSelect: function () {
          picker2.setMinDate(this.getDate());

          var newDate = this.getDate();
          var d = newDate.getDate();
          var m = ((newDate.getMonth() + 1) < 10 ? '0' : '') + (newDate.getMonth() + 1);
          var y = newDate.getFullYear();
          start_date = y+'-'+m+'-'+d;
          booking_url = 'https://'+body_location+'.nitesoft.se/units/'+start_date+'/'+end_date+'//2';
          $('.booking_btn').attr('href', booking_url);
        }
    });

    var picker2 = new Pikaday({
        field: document.getElementById('departure'),
        position: 'left-aligned',
        firstDay: 1,
        i18n: {
        previousMonth : 'Föregående månad',
        nextMonth     : 'Nästa månad',
        months        : ['Januari','Februari','Mars','April','Maj','Juni','Juli','Augusti','September','Oktober','November','December'],
        weekdays      : ['Söndag','Måndag','Tisdag','Onsdag','Torsdag','Fredag','Lördag'],
        weekdaysShort : ['Sön','Mån','Tis','Ons','Tor','Fre','Lör']
      },
      onSelect: function () {
        var newDate = this.getDate();
        var d = newDate.getDate();
        var m = ((newDate.getMonth() + 1) < 10 ? '0' : '') + (newDate.getMonth() + 1);
        var y = newDate.getFullYear();
        end_date = y+'-'+m+'-'+d;
        booking_url = 'https://'+body_location+'.nitesoft.se/units/'+start_date+'/'+end_date+'//2';
        $('.booking_btn').attr('href', booking_url);
      }
    });

    var picker3 = new Pikaday({
        field: document.getElementById('arrival-top'),
        position: 'left-aligned',
        firstDay: 1,
        i18n: {
        previousMonth : 'Föregående månad',
        nextMonth     : 'Nästa månad',
        months        : ['Januari','Februari','Mars','April','Maj','Juni','Juli','Augusti','September','Oktober','November','December'],
        weekdays      : ['Söndag','Måndag','Tisdag','Onsdag','Torsdag','Fredag','Lördag'],
        weekdaysShort : ['Sön','Mån','Tis','Ons','Tor','Fre','Lör']
        },
        minDate: new Date(),
        onSelect: function () {
          picker4.setMinDate(this.getDate());

          var newDate = this.getDate();
          var d = newDate.getDate();
          var m = ((newDate.getMonth() + 1) < 10 ? '0' : '') + (newDate.getMonth() + 1);
          var y = newDate.getFullYear();
          start_date = y+'-'+m+'-'+d;
          booking_url = 'https://'+header_location+'.nitesoft.se/units/'+start_date+'/'+end_date+'//2';
          $('.booking_btn').attr('href', booking_url);
        }
    });

    var picker4 = new Pikaday({
        field: document.getElementById('departure-top'),
        position: 'left-aligned',
        firstDay: 1,
        i18n: {
        previousMonth : 'Föregående månad',
        nextMonth     : 'Nästa månad',
        months        : ['Januari','Februari','Mars','April','Maj','Juni','Juli','Augusti','September','Oktober','November','December'],
        weekdays      : ['Söndag','Måndag','Tisdag','Onsdag','Torsdag','Fredag','Lördag'],
        weekdaysShort : ['Sön','Mån','Tis','Ons','Tor','Fre','Lör']
      },
      onSelect: function () {
        var newDate = this.getDate();
        var d = newDate.getDate();
        var m = ((newDate.getMonth() + 1) < 10 ? '0' : '') + (newDate.getMonth() + 1);
        var y = newDate.getFullYear();
        end_date = y+'-'+m+'-'+d;
        booking_url = 'https://'+header_location+'.nitesoft.se/units/'+start_date+'/'+end_date+'//2';
        $('.booking_btn').attr('href', booking_url);
      }
    });


});
